<template>
   <div class="box">
    <div id="title">
        ESTA FUNCIONALIDADE ESTÁ EM FASE DE DESENVOLVIMENTO
    </div>
    <div id="descricao">
        Lamentamos sinceramente o inconveniente causado.
Nossa equipe está empenhada em concluir essa parte da ferramenta o mais rapidamente possível
      
    </div>
    <a href="/" target="_blank">
      <img src="../assets/logosis.png" id="logo-task">
    </a>
  </div>
</template>

<script>
export default {

}
</script>

<style  scoped>

.box{
      background-color: #fff;
      width: 500px;
      margin: 50px auto;
    }
    #title {
      font-size: 30px;
      margin-top: 25px;
    }
    #descricao{
      font-size:20px;
      margin: 20px auto;
    }
    #logo {
      margin-top: 25px;
      max-width: 365px;
      height: auto;
    }
    #logo-task {
      width: 75px;
    }
</style>